import { gql } from '@apollo/client'
import { FirmFragments } from '../fragments/firm.fragments'
import { FirmProfileInfoFragments } from '../fragments/firmProfileInfo.fragments'

export const FirmAccountSettingsQuery = gql`
    query FirmQuery($id: String!) {
        firm(id: $id) {
            id
            name
            subscriptionInfo {
                ...subscriptionInfoFragment
            }
            displayName
            profileInfo {
                ...firmProfileInfoFragment
            }
            status
            supportContactUser {
                ...supportContactUserFragment
            }
            totalUsers
            totalReviewers
            isSpecTextLibraryVisible
        }
    }
    ${FirmFragments.subscriptionInfoFragment}
    ${FirmProfileInfoFragments.firmProfileInfoFragment}
    ${FirmFragments.supportContactUserFragment}
`

export const FirmDesignatedAccountAdminQuery = gql`
    query FirmDesignatedAccountAdmin($id: String!) {
        firm(id: $id) {
            id
            designatedAccountAdminUserId
        }
    }
`

export const FirmUsersQuery = gql`
    query getUsers($firmId: String!) {
        firm(id: $firmId) {
            id
            totalUsers
            totalReviewers
            areBestPracticesEnabled
            users {
                ...firmUsersFragment
            }
            designatedAccountAdminUserId
            subscriptionInfo {
                ...subscriptionInfoFragment
            }
        }
    }
    ${FirmFragments.firmUsersFragment}
    ${FirmFragments.subscriptionInfoFragment}
`
export const FirmUsersQueryNonRestricted = gql`
    query getUsers($firmId: String!) {
        firm(id: $firmId) {
            users {
                ...firmUsersFragment
            }
        }
    }
    ${FirmFragments.firmUsersFragment}
`
export const FirmUserCount = gql`
    query getFirmUserCountInfo($firmId: String!) {
        firm(id: $firmId) {
            id
            totalUsers
            totalReviewers
            subscriptionInfo {
                ...subscriptionInfoFragment
            }
        }
    }
    ${FirmFragments.subscriptionInfoFragment}
`
export const FirmSupportContactUserQuery = gql`
    query FirmSupportContactUser($firmId: String!) {
        firm(id: $firmId) {
            id
            designatedAccountAdminUser {
                id
                email
                status
                isDesignatedAccountAdminUser
                profileInfo {
                    firstName
                    lastName
                    phone
                }
            }
            name
            subscriptionInfo {
                salesforceId
            }
            isContentTeam
        }
    }
`

export const FirmProjectParametersQuery = gql`
    query FirmProjectParameters($firmId: String!) {
        firm(id: $firmId) {
            id
            projectGroups {
                ...firmProjectGroupFragment
            }
            associationModifierLists {
                ...associationModifierListsFragment
            }
            projectPhases {
                ...firmProjectPhasesFragment
            }
        }
    }
    ${FirmFragments.firmProjectGroupFragment}
    ${FirmFragments.associationModifierListsFragment}
    ${FirmFragments.firmProjectPhasesFragment}
`

export const FirmProjectPhasesQuery = gql`
    query FirmProjectPhases($firmId: String!) {
        firm(id: $firmId) {
            id
            projectPhases {
                ...firmProjectPhasesFragment
            }
        }
    }
    ${FirmFragments.firmProjectPhasesFragment}
`

export const FirmProfessionalDisciplineQuery = gql`
    query FirmProfessionalDiscipline($firmId: String!) {
        firm(id: $firmId) {
            id
            professionalDisciplines {
                ...firmProfessionalDisciplinesFragment
            }
        }
    }
    ${FirmFragments.firmProfessionalDisciplinesFragment}
`
export const FirmUsersProjectMembershipQuery = gql`
    query getFirmUserProjectMembership(
        $firmId: String!
        $projectId: String!
        $resultInput: GetResultsInput!
    ) {
        firm(id: $firmId) {
            id
            usersWithProjectMembership(
                projectId: $projectId
                input: $resultInput
            ) {
                count
                users {
                    isAssignedToProject
                    projectRole
                    user {
                        ...firmUsersFragment
                    }
                }
            }
        }
    }
    ${FirmFragments.firmUsersFragment}
`

export const FirmUsersProjectMembershipCountQuery = gql`
    query getFirmUserProjectMembership(
        $firmId: String!
        $projectId: String!
        $resultInput: GetResultsInput!
    ) {
        firm(id: $firmId) {
            id
            usersWithProjectMembership(
                projectId: $projectId
                input: $resultInput
            ) {
                count
            }
        }
    }
`
